































































  import {Component, Ref, Vue} from "vue-property-decorator"
  import {vxm} from "@/store"

  @Component
  export default class AdminSiteCreate extends Vue {

    private id: number | null = null

    private name: string = ""
    private domain: string = ""
    private image: string | null = null
    private change_image: boolean = false
    private title_regexp: string | undefined = ""
    private title_replacement: string | undefined = ""
    private body_regexp: string | undefined = ""
    private body_replacement: string | undefined = ""
    private append_parameter: string | undefined = ""

    @Ref() private file!: HTMLInputElement

    async mounted() {
      if (this.$route.params.id) {
        this.id = parseInt(this.$route.params.id)
        const site = vxm.site.sites.find(site => site.id === this.id)
        if (site) {
          this.name = site.name
          this.domain = site.domain
          if (site.image) {
            this.image = "/" + site.image
          }
          this.title_regexp = site.title_regexp
          this.title_replacement = site.title_replacement
          this.body_regexp = site.body_regexp
          this.body_replacement = site.body_replacement
          this.append_parameter = site.append_parameter
        }
      }
    }

//
    async onSave() {
      if (this.id) {
        await vxm.site.edit({
          id               : this.id,
          name             : this.name,
          domain           : this.domain,
          image            : this.change_image ? this.image : null,
          title_regexp     : this.title_regexp,
          title_replacement: this.title_replacement,
          body_regexp      : this.body_regexp,
          body_replacement : this.body_replacement,
          append_parameter : this.append_parameter
        })
      } else {
        await vxm.site.create({
          name             : this.name,
          domain           : this.domain,
          image            : this.image,
          title_regexp     : this.title_regexp,
          title_replacement: this.title_replacement,
          body_regexp      : this.body_regexp,
          body_replacement : this.body_replacement,
          append_parameter : this.append_parameter
        })
      }
      await this.$router.push({name: "AdminSiteList"})
    }

    onClickUpload() {
      this.file.click()
    }

    onChangeFile(e: any) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e: any) => {
        this.image = e.target.result || ""
      }
      reader.readAsDataURL(file)
      this.change_image = true
    }

    onClickDeleteImage() {
      this.image = null
      this.change_image = true
    }
  }
